<template>

    <div>
        <h1 class="text-4xl my-24 text-center font-headings">Style Guide - Software</h1>
    </div>

    <ContentWrapper class="py-12">
        <div>
            <div>Device Screenshots</div>
            <div>
                <ul class="list-disc list-inside">
                    <li>Screenshots should be generated by the screenshot tool</li>
                    <li>Phone Resolution is iPhone 16 Pro - 1320 x 2868</li>
                    <li>Tablet Resolution is iPad Pro in Landscape - 2732 x 2048</li>
                    <li>Nav and Status bars match the iPhone sizes</li>
                    <li>Nav bar has full battery, no signal or network, and a time of 20:01</li>
                    <li>We do not show the notch/cutout unless submitting to app store</li>
                    <li>Device Screens have rounded corners of x%</li>
                </ul>
            </div>

            <div>CMS Screenshots</div>
            <div>
                <ul>
                    <li>Always use the Primary Demo unless otherwise specified</li>
                    <li>Do not show browser toolbars or icons </li>
                    <li>Do not show scrollbars</li>
                    <li>Screen Resolution should be 1536 x 864 (16:9), not too zoomed out </li>
                    <li></li>
                </ul>
            </div>
        </div>
    </ContentWrapper>


    <ContentWrapper class="py-12">
        <div class="max-w-7xl mx-auto">
            <div class="text-2xl font-headings mb-2 text-gray-800">Software</div>

            <div class="mb-8 space-y-4">
                <div class="flex items-center gap-4">
                    <label class="w-20 text-sm font-medium">Width:</label>
                    <input 
                        type="range" 
                        min="0" 
                        max="10" 
                        step="0.1"
                        v-model.number="width" 
                        class="flex-1"
                    />
                    <span class="w-16 text-sm text-gray-600">{{ width }}</span>
                </div>
                
                <div class="flex items-center gap-4">
                    <label class="w-20 text-sm font-medium">X:</label>
                    <input 
                        type="range" 
                        min="-180" 
                        max="180" 
                        step="1"
                        v-model.number="x" 
                        class="flex-1"
                    />
                    <span class="w-16 text-sm text-gray-600">{{ x }}°</span>
                </div>
                
                <div class="flex items-center gap-4">
                    <label class="w-20 text-sm font-medium">Y:</label>
                    <input 
                        type="range" 
                        min="-180" 
                        max="180" 
                        step="1"
                        v-model.number="y" 
                        class="flex-1"
                    />
                    <span class="w-16 text-sm text-gray-600">{{ y }}°</span>
                </div>
                
                <div class="flex items-center gap-4">
                    <label class="w-20 text-sm font-medium">Z:</label>
                    <input 
                        type="range" 
                        min="-180" 
                        max="180" 
                        step="1"
                        v-model.number="z" 
                        class="flex-1"
                    />
                    <span class="w-16 text-sm text-gray-600">{{ z }}°</span>
                </div>
            </div>

            <div class="relative bg-blue-100" style="height: 500px; width:500px;">
                <DeviceWrapper :width="width * 10" device-type="phone" :imageSrc="leadCapture1" :z="z" :y="y" :x="x" class="z-20 absolute">
                    <template #overlay>
                        <div class="w-32 h-24 bg-white absolute top-12 left-12 shadow-lg rounded-tl rounded-br">

                        </div>

                        <div class="w-32 h-24 bg-white absolute top-48 right-12 shadow-lg rounded-tl rounded-br">
                            Scan
                        </div>

                        <div class="w-32 h-24 bg-green-500 absolute top-96 left-12 shadow-lg rounded-tl rounded-br">
                            
                        </div>
                    </template>
                </DeviceWrapper>
                
            </div>
        </div>
    </ContentWrapper>


</template>

<script setup>
import { ref } from 'vue';
import ContentWrapper from '../components/Layouts/ContentWrapper.vue'
import DeviceWrapper from '../components/DeviceWrapper.vue'
import leadCapture1 from '@/images/lead-capture-1.jpg';

const width = ref(2); // 0-10 scale, multiplied by 10 for percentage (default 2 = 20%)
const x = ref(0);
const y = ref(-15);
const z = ref(0);

</script>